import React, { Component, useEffect, useState } from "react";
import axios from "axios";
import { Button, CircularProgress, Popover } from "@material-ui/core";
import ReviewModal from "./reviewModal";
import { format } from "date-fns";
import { useNotification } from "../../../../Notifications/NotificationProvider";
import bkash from "../../../svgs/bKash_Logo_Icon_Outlined.svg";
import route from "../../../svgs/route.svg";
import history from "../../../svgs/history.svg";
import location from "../../../svgs/location_on.svg";
import done from "../../../svgs/done_all.svg";
import reason from "../../../svgs/edit_note.svg";
import pending from "../../../svgs/calendar_month.svg";
import rejected from "../../../svgs/Close cr-fr 1.svg";
import store from "../../../svgs/storefront.svg";
import "../styles/transferList.scss";

const statusConfig = {
  REQ_APPROVED: {
    title: "Approved",
    className: "approve",
    icon: done,
    noun: "Aprroval",
  },
  REQ_DENIED: {
    title: "Rejected",
    className: "reject",
    icon: rejected,
    noun: "Rejection",
  },
  REQ_SUBMITTED: {
    title: "Pending",
    className: "pending",
    icon: pending,
    noun: "Requested",
  },
};

export default function TransferList({
  transferList,
  loadTrasnferList,
  filter,
}) {
  return (
    <div className="transfer-list-container">
      {transferList.filter((i) => filter === "ALL" || i.status === filter)
        .length > 0 ? (
        transferList
          .filter((i) => filter === "ALL" || i.status === filter)
          .map((item) => (
            <TransferListItem
              key={item.id}
              item={item}
              loadTrasnferList={loadTrasnferList}
            />
          ))
      ) : (
        <div className="blank-list-text">
          No {statusConfig[filter] && statusConfig[filter].title.toLowerCase()}{" "}
          item
        </div>
      )}
    </div>
  );
}

function TransferListItem({ item, loadTransferList }) {
  const [isOpenReviewModal, setIsOpenReviewModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const dispatchNotification = useNotification();

  const handleClickRejectPop = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseRejectPop = () => {
    setAnchorEl(null);
  };
  const postReview = (action) => {
    setLoading(true);
    const obj = {
      id: item.id,
      action_type: action,
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/route_management/v1/route-transfer`,
        obj,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        setLoading(false);
        loadTransferList();
        dispatchNotification({
          type: "SUCCESS",
          message: "Rejected route trasnfer request",
        });
      })
      .catch((err) => {
        setLoading(false);
        dispatchNotification({
          type: "ERROR",
          message: "Something went wrong",
        });
      });
  };
  return (
    <div
      key={item.current_route_id + item.field_force_id}
      className="transfer-item"
    >
      <ReviewModal
        open={isOpenReviewModal}
        setOpen={setIsOpenReviewModal}
        details={item}
        loadTransferList={loadTransferList}
      />

      <div className="chip-container">
        <p className={statusConfig[item.status].className}>
          {statusConfig[item.status].title}
        </p>
      </div>

      <div className="outlet-name">
        <img src={store} style={{ width: 18 }} alt="bkash" />
        <div>
          <p>Merchant</p>
          {item.outlet__name}
        </div>
      </div>
      <div className="info">
        <img src={bkash} alt="bkash" />
        <div>
          <p>Bkash wallet no</p>
          {item.outlet__wallet_no}
        </div>
      </div>
      <div className="info">
        <img src={route} alt="bkash" />
        <div>
          <p>Route</p>
          {item.current_route__name}
        </div>
      </div>
      <div className="info">
        <img src={bkash} alt="bkash" />
        <div>
          <p>Field force</p>
          {item.field_force__name}
        </div>
      </div>
      <div className="info">
        <img src={bkash} alt="bkash" />
        <div>
          <p>Whitelisting number </p>
          {item.field_force__whitelisting_number}
        </div>
      </div>
      <div className="info">
        <img src={location} alt="bkash" />
        <div>
          <p>Address</p>
          {item.outlet__address}
        </div>
      </div>
      <div className="info">
        <img src={reason} alt="bkash" />
        <div>
          <p>Reason</p>
          {item.reason}
        </div>
      </div>
      <div className="info">
        <img src={statusConfig[item.status].icon} alt="bkash" />
        <div>
          <p>{statusConfig[item.status].noun} date and time</p>
          {format(new Date(item.action_date), "dd MMM yyyy, h:mm a")}
        </div>
      </div>
      {/* <Popover
        id={"reject-pop"}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseRejectPop}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div className="reject-popover">
          <h2>Are you sure want to reject this transfer request ?</h2>
        </div>
      </Popover> */}
      {item.status === "REQ_SUBMITTED" && (
        <div className="button-container">
          <Button
            className="button reject"
            onClick={() => postReview("REQ_DENIED")}
            //onClick={handleClickRejectPop}
          >
            {loading && (
              <CircularProgress
                style={{ marginRight: 5, color: "rgba(238, 50, 53, 1)" }}
                size={12}
              />
            )}
            {loading ? "Rejecting" : "Reject"}
          </Button>
          <Button
            className="button review"
            onClick={() => setIsOpenReviewModal(true)}
          >
            Review
          </Button>
        </div>
      )}
    </div>
  );
}
